import { useScriptIntercom, useScript } from "#imports";

/**
 * Wrapper for Intercom Nuxt Script
 */
export const useIntercomScriptWrapper = (options: any) => {
  return useScriptIntercom(options);
};

/**
 * Wrapper for Generic Nuxt Script
 */
export const useGenericScriptWrapper = <T extends Record<string | symbol, any>>(
  script: any,
  options: any,
) => {
  return useScript<T>(script, options);
};
